import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectObjective } from "../Model/ProposalProjectObjective";

export async function getProposalProjectObjective(idProposalProject) {
	let response = await getAPIResponse("/v1/proposal-project-objective/"+idProposalProject);
	if (response === null) {
		return null;
	}
	let proposalProjectObjective = response.map(data => ProposalProjectObjective.createFromResponseData(data));
	return proposalProjectObjective;
}
